// PROTOTYPE
// This Component is highly subject to change
// This button is specifically designed for use in ProtoColumnB
import React, { useContext } from 'react'
import { css } from 'emotion'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import ThemeContext from 'src/libraries/contexts/Theme'

const ProtoColumnNavButton = ({
   borderStyle,
   color,
   icon,
   linkExact,
   linkName,
   linkTo
}) => {
   const theme = useContext(ThemeContext)

   return (
      <NavLink
         exact={linkExact}
         to={linkTo}
         className={css`
            color: #555;
            display: block;
            width: 100%;

            &:hover {
               background-color: rgba(0,0,0,0.02);
            }

            .dot {
               background-color: rgba(0,0,0,0.05);
            }

            .icon {
               fill: #888;
            }
         `}
         activeClassName={css`
            background-color: rgba(0,0,0,0.05);
            color: #000 !important;

            &:hover {
               background-color: rgba(0,0,0,0.05);
            }

            .dot {
               background-color: ${theme.protoSettingsHighlightBackgroundColor} !important;
            }

            .icon {
               fill: ${theme.protoSettingsHighlightForegroundColor} !important;
            }
         `}>
         <View
            display="flex"
            alignItems="center"
            padding="10px 20px"
            borderTop={borderStyle}>
            <View
               display="flex"
               justifyContent="center"
               alignItems="center"
               className="dot"
               width="28px"
               height="28px"
               borderRadius="50%"
               marginRight="15px"
               marginTop="1px"
               textAlign="center">
               {icon}
            </View>
            <Text size="1.5" weight="medium" color="inherit">
               {linkName}
            </Text>
         </View>
      </NavLink>
   )
}

ProtoColumnNavButton.propTypes = {
   borderStyle: PropTypes.string,
   color: PropTypes.string,
   icon: PropTypes.node,
   linkExact: PropTypes.bool,
   linkName: PropTypes.string.isRequired,
   linkTo: PropTypes.string.isRequired
}

ProtoColumnNavButton.defaultProps = {
   borderStyle: '1px solid rgba(0,0,0,0.05)',
   color: '#f7b77c',
   icon: undefined,
   linkExact: false
}

export default ProtoColumnNavButton
